const HUB_TASK_SECTION_ORDER = ['home-sale', 'home-purchase', 'mortgage', 'account'] as const;
const HUB_DISCOVERY_SECTION_ORDER = [
  'home-tours',
  'saved-homes',
  'recommendations',
  'explore-new-homes',
] as const;

type HubTaskSectionId = (typeof HUB_TASK_SECTION_ORDER)[number];
type HubDiscoverySectionId = (typeof HUB_DISCOVERY_SECTION_ORDER)[number];
export type HubSectionId = HubTaskSectionId | HubDiscoverySectionId;

export interface HubSection<TContent> {
  id: HubSectionId;
  content: TContent;
}

const getHubSectionRank = (id: HubSectionId): number => {
  const taskRank = HUB_TASK_SECTION_ORDER.indexOf(id as HubTaskSectionId);
  if (taskRank >= 0) {
    return taskRank;
  }

  return (
    HUB_TASK_SECTION_ORDER.length + HUB_DISCOVERY_SECTION_ORDER.indexOf(id as HubDiscoverySectionId)
  );
};

export const orderHubSections = <TContent>(
  sections: Array<HubSection<TContent>>,
): Array<HubSection<TContent>> =>
  sections
    .map((section, index) => ({ section, index }))
    .sort(
      (a, b) =>
        getHubSectionRank(a.section.id) - getHubSectionRank(b.section.id) || a.index - b.index,
    )
    .map(({ section }) => section);
